module.exports = __webpack_public_path__ + "static/media/AER_AI_354_AND_388_VISUALIZED.67637c24.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/utils/legend/AER_AI_354_AND_388_VISUALIZED.PNG
// module id = 1069
// module chunks = 0